<template>
  <el-main>
    <el-row class="front-row">
      <el-col :lg="containerSize.one.lg" :md="0" :sm="0" :xs="0" class="display-section" :class="{ compact }" :style="{backgroundImage: `url('${bg}')`}">
        <div class="section-mask"></div>
        <transition name="jump" mode="out-in">
          <div class="section-title-with-image" v-if="compact" key="one">
            <img :src="mockupImage" alt="">
            <h1>Sign up for the <span>Divegas</span> diver platform</h1>
          </div>
          <div class="section-title" key="two" v-else>
            <div v-if="invoice">
              <h1>Divegas</h1>
            </div>
            <div v-else>
              <h1>The <span>Divegas</span> diver platform</h1>
              <h2><fa :icon="rightSectionLabel.icon" /> {{ rightSectionLabel.text }}</h2>
            </div>
          </div>
        </transition>
      </el-col>
      <el-col :lg="containerSize.two.lg" :md="24" :sm="24" :xs="24" style="overflow-x: hidden;">
        <transition :name="transitionName" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
import Header from '@/components/front/Header'
import Mockup from '@/assets/mockup.png'
import Bg from '@/assets/dg1_ny.jpg'
export default {
  components: { 'pg-header': Header },
  name: 'Test',
  data () {
    return {
      compact: false,
      invoice: false,
      mockupImage: Mockup,
      bg: Bg
    }
  },
  computed: {
    transitionName () {
      if (this.$route.name === 'Forgot') {
        return 'slide-right'
      }

      return this.compact ? 'jump' : 'slide-left'
    },
    rightSectionLabel () {
      if (this.compact) {
        return {
          text: 'Signup',
          icon: 'address-card'
        }
      } else {
        return {
          text: 'Signin',
          icon: 'lock'
        }
      }
    },
    containerSize () {
      if (this.invoice) {
        return {
          one: {
            lg: 12,
            md: 12
          },
          two: {
            lg: 12,
            md: 12
          }
        }
      }

      if (this.compact) {
        return {
          one: {
            lg: 12,
            md: 12
          },
          two: {
            lg: 12,
            md: 8
          }
        }
      }

      return {
        one: {
          lg: 17,
          md: 18
        },
        two: {
          lg: 7,
          md: 6
        }
      }
    }
  },
  methods: {},
  watch: {
    '$route' (to, from) {
      this.compact = this.$route.meta.compact
      this.invoice = this.$route.meta.invoice

      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
    }
  },
  mounted () {
    this.compact = this.$route.meta.compact
    this.invoice = this.$route.meta.invoice
  }
}
</script>

<style lang="scss" scoped>
  .front-row {
    background-color: white;
  }

  .display-section {
    position: relative;
    height: 100vh;
    background-color: $main;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    transition: width .2s ease-out; 
    overflow: hidden;

    .section-mask {
      background-color: rgba(black, 0.4);
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100vh;
    }

    .section-title {
      position: absolute;
      right: 80px;
      bottom: 80px;
      z-index: 2;

      h2 {
        margin: 0;
        color: white;
        font-size: 22px;
        text-align: right;

        svg {
          margin-right: 10px;
        }
      }

      h1 {
        font-weight: 500;
        margin: 0;
        font-size: 60px;
        color: white;

        span {
          color: $main;
        }
      }
    }

    .section-title-with-image {
      @extend .section-title;
      height: 100vh;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      right: 0px;
      bottom: -10px;

      img {
        width: 700px;
        height: auto;
      }

      h1 {
        font-size: 22px;
        text-align: center;
        width: 100%;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/front/Front.vue